import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { PointSource } from '../models/registration-points.model';

export const NameChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Name Changed',
  props<{ recipeDisplayName: string }>(),
);

export const SchemaChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Schema Changed',
  props<{ selectedSchema: string }>(),
);

export const PointSourceChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Point Source Changed',
  props<{ selectedPointSourceId: number }>(),
);

export const PointsChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: PointsChanged Changed',
  props<{ selectedPoints: number }>(),
);

export const RemarkChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Remark Changed',
  props<{ selectedRemark: string }>(),
);

export const PointExpirationTypeChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Point Expiration Type Changed',
  props<{ pointExpirationType: string }>(),
);

export const PointExpirationValueChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Point Expiration Value Changed',
  props<{ pointExpirationValue: any }>(),
);

export const StartDateChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: StartDate Changed',
  props<{ startDate: string }>(),
);

export const StartDateCleared = createAction(
  '[Recipes - Full Registration Points Create/Update]: StartDate Cleared',
);

export const EndDateChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: EndDateChanged Changed',
  props<{ endDate: string }>(),
);

export const EndDateCleared = createAction(
  '[Recipes - Full Registration Points Create/Update]: EndDateChanged Cleared',
);

export const InactiveChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Inactive Changed',
  props<{ inactive: boolean }>(),
);

export const DescriptionChanged = createAction(
  '[Recipes - Full Registration Points Create/Update]: Description Changed',
  props<{ description: string }>(),
);

export const UpdateRecipeFR = createAction(
  '[Recipes - Full Registration Points Create/Update]: Update Recipe',
);
export const UpdateRecipeSuccess = createAction(
  '[Recipes - Full Registration Points Create/Update]: Update Recipe Success',
  props<{ response: any }>(),
);
export const UpdateRecipeFail = createAction(
  '[Recipes - Full Registration Points Create/Update]: Update Recipe Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateRecipeFR = createAction(
  '[Recipes - Full Registration Points Create/Update]: Create Recipe',
);
export const CreateRecipeSuccess = createAction(
  '[Recipes - Full Registration Points Create/Update]: Create Recipe Success',
  props<{ response: any }>(),
);
export const CreateRecipeFail = createAction(
  '[Recipes - Full Registration Points Create/Update]: Create Recipe Fail',
  props<{ error: HttpErrorResponse }>(),
);

export const SubmitDataFR = createAction(
  '[Recipes - Full Registration Points Create/Update]: Submit Data',
);

export const PointSourcesInit = createAction(
  '[Recipes - Full Registration Points Create/Update]: Point Sources Init',
);

export const PointSourcesSuccess = createAction(
  '[Recipes - Full Registration Points Create/Update]: Point Sources Success',
  props<{ pointSources: PointSource[] }>(),
);
export const PontSourcesFailure = createAction(
  '[Recipes - Full Registration Points Create/Update]: Point Sources Failed',
  props<{ error: HttpErrorResponse }>(),
);
